<template>
  <div class="all">
    <backHeader back-addr="/person"></backHeader>
    <van-divider
      :style="{ color: 'rgb(212, 9, 9)', borderColor: 'rgb(212, 9, 9)', padding: '0 16px' }"
    >总体数据</van-divider>

    <van-grid :column-num="2">
      <van-grid-item icon="eye-o" :text="'浏览总次数:'+viewCount" />
      <van-grid-item icon="user-o" :text="'登录总次数:'+loginCount" />
    </van-grid>

    <!-- <div style="margin-top:50px;"></div> -->
    <!-- <div class="total"><van-tag color="rgb(212, 9, 9)" plain size="large">浏览总次数:{{viewCount}}</van-tag></div>
    <div class="total"><van-tag color="rgb(212, 9, 9)" plain size="large">登录总次数:{{loginCount}}</van-tag></div>-->
    <van-divider
      :style="{ color: 'rgb(212, 9, 9)', borderColor: 'rgb(212, 9, 9)', padding: '0 16px' }"
    >今日统计</van-divider>

    <van-tabs v-model="active">
      <van-tab title="今日未登录">
        <div class="today">共计{{notLoginStudent.length}}</div>
        <van-list style="margin-bottom:70px;">
          <van-cell
            style="text-align:center"
            v-for="item in notLoginStudent"
            :key="item.id"
            :title="item.userNumber+'            '+item.userName"
          />
        </van-list>
      </van-tab>
      <van-tab title="今日已登录">
        <div class="today">共计{{loginStudent.length}}</div>
        <van-list style="margin-bottom:70px;">
          <van-cell
            style="text-align:center"
            v-for="item in loginStudent"
            :key="item.id"
            :title="item.userNumber+'            '+item.userName"
          />
        </van-list>
      </van-tab>
      <van-tab title="今日登录查询">
        <br />
        <van-field
          readonly
          clickable
          name="picker"
          :value="studentInfo"
          label="学生信息"
          placeholder="点击选择学院、专业"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>

        <br />
        <div style="text-align:center;">
          <van-button type="danger" size="small" @click="checkStudent">查询</van-button>
        </div>

        <br />
        <div
          style="text-align:center;"
          v-if="checkStudentList.length!=0"
        >共有{{checkStudentList.length}}</div>
        <br />
        <van-list style="margin-bottom:70px;">
          <van-cell
            style="text-align:center"
            v-for="item in checkStudentList"
            :key="item"
            :title="item"
          />
        </van-list>
      </van-tab>

      <van-tab title="登录天数统计">
        <br />
        <van-field
          readonly
          clickable
          name="picker"
          :value="studentInfoDay"
          label="学生信息"
          placeholder="点击选择学院、专业"
          @click="showPickerDay = true"
        />
        <van-popup v-model="showPickerDay" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirmDay"
            @cancel="showPickerDay = false"
          />
        </van-popup>

        <br />
        <div style="text-align:center;">
          <van-button type="danger" size="small" @click="checkStudentDay">查询</van-button>
        </div>

        <br />
        <div
          style="text-align:center;"
          v-if="checkStudentListDay.length!=0"
        >共有{{checkStudentListDay.length}}</div>
        <br />
        <van-list style="margin-bottom:70px;">
          <van-cell
            style="text-align:center"
            v-for="item in checkStudentListDay"
            :key="item"
            :title="item"
          />
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import backHeader from "./../components/back-header.vue";
//
import { MessageBox, Toast } from "mint-ui";
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";

export default {
  name: "all",
  data() {
    return {
      studentInfo: "", //筛选过滤条件-----》基础医学院,护理学,18护理1班
      studentInfoDay: "", //天数统计里的筛选条件
      checkStudentList: [], //筛选出的学生的列表
      checkStudentListDay: [],

      //wyk20200520 第三版
      columns: [
        {
          text: "黑龙江省医院",
          children: [
            {
              text: "卫生监督"
            },
            {
              text: "预防医学"
            }
          ]
        },

        {
          text: "生物信息科学与技术学院",
          children: [
            {
              text: "生物医学工程"
            },
            {
              text: "生物技术"
            },
            {
              text: "生物信息学"
            }
          ]
        },
        {
          text: "第一临床医学院",
          children: [
            {
              text: "临床医学"
            },
            {
              text: "儿科学"
            }
          ]
        },
        {
          text: "第二临床医学院",
          children: [
            {
              text: "麻醉学"
            },
            {
              text: "临床医学"
            }
          ]
        },
        {
          text: "第三临床医学院",
          children: [
            {
              text: "医学影像学"
            }
          ]
        },
        {
          text: "第四临床医学院",
          children: [
            {
              text: "临床医学"
            }
          ]
        },
        {
          text: "人文社会科学学院",
          children: [
            {
              text: "市场营销"
            },
            {
              text: "法学"
            }
          ]
        },
        {
          text: "基础医学院",
          children: [
            {
              text: "护理学"
            },
            {
              text: "临床医学"
            },
            {
              text: "基础医学"
            }
          ]
        },
        {
          text: "药学院",
          children: [
            {
              text: "临床药学"
            },
            {
              text: "药学"
            }
          ]
        },
        {
          text: "公共卫生学院",
          children: [
            {
              text: "公共事业管理"
            }
          ]
        },
        {
          text: "护理学院",
          children: [
            {
              text: "护理学"
            }
          ]
        },
        {
          text: "口腔医学院",
          children: [
            {
              text: "口腔医学"
            }
          ]
        }
      ],

      //第二版
      // columns: [
      //   {
      //     text: "第二临床医学院",
      //     children: [
      //       {
      //         text: "麻醉学"
      //       }
      //     ]
      //   },
      //   {
      //     text: "人文社会科学学院",
      //     children: [
      //       {
      //         text: "市场营销"
      //       },
      //       {
      //         text: "法学"
      //       }
      //     ]
      //   },
      //   {
      //     text: "基础医学院",
      //     children: [
      //       {
      //         text: "护理学"
      //       }
      //     ]
      //   },
      //   {
      //     text: "药学院",
      //     children: [
      //       {
      //         text: "临床药学"
      //       }
      //     ]
      //   }
      // ],

      // columns: [
      //   {
      //     text: "第二临床医学院",
      //     children: [
      //       {
      //         text: "麻醉学",
      //         children: [{ text: "17麻醉1班" }, { text: "17麻醉2班" }]
      //       }
      //     ]
      //   },
      //   {
      //     text: "人文社会科学学院",
      //     children: [
      //       {
      //         text: "市场营销",
      //         children: [{ text: "17营销1班" }, { text: "17营销2班" }]
      //       },
      //       {
      //         text: "法学",
      //         children: [{ text: "18法学1班" }, { text: "18法学2班" }]
      //       }
      //     ]
      //   },
      //   {
      //     text: "基础医学院",
      //     children: [
      //       {
      //         text: "护理学",
      //         children: [
      //           { text: "18护理1班" },
      //           { text: "18护理2班" },
      //           { text: "18护理3班" },
      //           { text: "18护理4班" }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     text: "药学院",
      //     children: [
      //       {
      //         text: "临床药学",
      //         children: [
      //           { text: "18临药1班" },
      //           { text: "18临药2班" },
      //           { text: "18临药3班" },
      //           { text: "18临药4班" }
      //         ]
      //       }
      //     ]
      //   }
      // ],
      // columns: ['麻醉学', '市场营销', '法学', '护理学', '临床药学'],
      showPicker: false,
      showPickerDay: false,

      active: 1,
      viewCount: 0,
      loginCount: 0,
      loginStudent: [],
      notLoginStudent: []
    };
  },
  methods: {
    onConfirmDay(value) {
      //fix bug  20200914 专业中有特殊字符+的bug eg:基础医学院,2019,基础医学（5+2）  https://www.cnblogs.com/chenqingbin/p/11511833.html
      this.studentInfoDay = value.join(",");
      this.showPickerDay = false;

      console.log(this.studentInfoDay);
    },
    checkStudentDay() {
      if (this.studentInfoDay == "") {
        Toast({
          message: "查询的学生信息不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      console.log("checkStudent");
      this.checkStudentListDay = [];

      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "user/checkStudentDay?studentInfoDay=" +
            this.studentInfoDay.replace('+', '%2B')
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //如果数据为空
            if (res.data.returnData == null) {
              Toast({
                message: "无登录记录!!",
                position: "bottom",
                duration: 800
              });
            } else {
              this.checkStudentListDay = res.data.returnData;
            }
          } else {
            Toast({
              message: res.data.returnMsg,
              position: "bottom",
              duration: 800
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkStudent() {
      if (this.studentInfo == "") {
        Toast({
          message: "查询的学生信息不得为空！",
          position: "bottom",
          duration: 800
        });
        return;
      }
      console.log("checkStudent");
      this.checkStudentList = [];

      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "user/checkStudent?studentInfo=" +
            this.studentInfo.replace('+', '%2B')
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //如果数据为空
            if (res.data.returnData == null) {
              Toast({
                message: "今日无登录记录!!",
                position: "bottom",
                duration: 800
              });
            } else {
              this.checkStudentList = res.data.returnData;
            }
          } else {
            Toast({
              message: res.data.returnMsg,
              position: "bottom",
              duration: 800
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onConfirm(value) {
      this.studentInfo = value.join(",");
      this.showPicker = false;

      console.log(this.studentInfo);
    },
    initAllData() {
      axios
        .get(Addr.getGoNewAPIPrefix() + "user/all")
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.viewCount = res.data.returnData.viewCount;
            this.loginCount = res.data.returnData.loginCount;
            //fix bug 如果没人登录
            if (res.data.returnData.loginStudent != null) {
              this.loginStudent = res.data.returnData.loginStudent;
            }
            if (res.data.returnData.notLoginStudent != null) {
              this.notLoginStudent = res.data.returnData.notLoginStudent;
            }
          } else {
            Toast({
              message: res.data.returnMsg,
              position: "bottom",
              duration: 800
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {},
  mounted: function() {
    //20200615
    axios
      .get(Addr.getGoNewAPIPrefix() + "user/listUserAcademy")
      .then(res => {
        console.log("academy res is:");
        console.log(res);
        if (res.status == 200) {
          console.log("200");
          this.columns = res.data;
        }
      })
      .catch(err => {
        console.log(err);
      });

    this.initAllData();
  },
  components: { backHeader }
};
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";
// @import "vant/lib/index.css";
.all {
  .total {
    text-align: center;
    margin: 10px;
  }
  .today {
    margin: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/module-data/all.vue